import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/DayPicker'
import FormRow from 'modules/core/components/FormRow'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { dateBackendToUI, dateUIToBackend } from 'modules/core/lib/dates'
import { firstDayOfWeekAsIndex } from 'modules/core/lib/firstDayOfWeek'
import i18n from 'modules/core/lib/i18n'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

type DateValues = [string | undefined, string | undefined]

interface Props {
  form: ReportsForm
}

const ExportMonthSelector = ({ form }: Props) => {
  const { access } = useCurrentSession()
  const startDate = form.get('from')
  const endDate = form.get('to')

  const firstDayOfWeek = firstDayOfWeekAsIndex(access.firstDayOfWeek)

  const onChangeEvent = (values: DateValues) => {
    const [startValue, endValue] = values

    const start = startValue ? dateBackendToUI(startValue) : undefined
    const end = endValue ? dateBackendToUI(endValue) : undefined

    startDate.set(start)
    endDate.set(end)
  }

  return (
    <FormRow>
      <DayPicker
        mode="range"
        format={'ui_dmy_long'}
        label={i18n.t('time_off.date_range.label')}
        onChange={onChangeEvent}
        value={[
          startDate.value ? dateUIToBackend(startDate.value) : undefined,
          endDate.value ? dateUIToBackend(endDate.value) : undefined,
        ]}
        firstDayOfWeek={firstDayOfWeek}
        focusTrapActive={false}
      />
    </FormRow>
  )
}

export default observer(ExportMonthSelector)
